export const INVALIDATION_TIP = {
  FILL_YOURSELF_INFORMATION:
    'Для получения подарка, заполните информацию о себе в ',
  INCORRECT_PHONE: "Некорректный номер телефона",
  INCORRECT_EMAIL: "Некорректный email",
  FIELD_REQUIRED: 'Обязательное поле',
  MIN_CODE_LENGTH: 'Код должен содержать 4 цифры',
  INCORRECT_CODE: 'код может содержать только числа',
  INCORRECT_CODE_LENGTH: 'код должен содержать 6 символов',
  INCORRECT_NAME: 'имя может содержать только буквы (латиницей или кириллицей)',
  MIN_LENGTH_NAME: 'имя должно содержать минимум 2 буквы',
  INCORRECT_NAME_NO_NUMBER: 'Имя не может содержать цифры',
  MIN_LENGTH_PASSWORD: 'Пароль должен содержать минимум 8 символов',
  MAX_LENGTH_PASSWORD: 'Пароль должен содержать максимум 16 символов',
  INCORRECT_PASSWORD: 'Пароль должен содержать: хотя бы одно число, одну латинскую букву в верхнем и одну букву в нижнем регистрах',
  MATCHES_OLD_PASSWORD: 'пароль не должен совпадать со старым',
  MATCHES_PASSWORD: 'Пароли не совпадают',
  MATCHES_OLD_EMAIL: 'почта не должна совпадать со старой',
  INCORRECT_CODE_SMS: 'Не верный код из SMS'
}

export const  REGEX = {
  VALID_CUSTOM_NAME: /^([^0-9]*)$/,
  VALID_NAME: /^[a-zA-Zа-яёА-ЯЁ]+$/u,
  VALID_PASSWORD: /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{6,}/g,
  VALID_EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  FULL_NAME_REGEX: /[A-Za-zА-Яа-яЁё]+(\s+[A-Za-zА-Яа-яЁё]+)?/,
}
